import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/newsletter`, { email });
      setDone(true);
      toast.success(res.data.message || "You're in.");
    } catch (err) {
      const msg =
        err?.response?.status === 422
          ? "Please enter a valid email address."
          : "Something went wrong. Please try again.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="newsletter" data-testid="newsletter-section" className="py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-[2.5rem] bg-[#e85d04] px-8 py-16 sm:px-16 sm:py-20">
          <div className="pointer-events-none absolute -top-20 -right-20 h-80 w-80 rounded-full bg-white/10 blur-2xl" />
          <div className="relative z-10 max-w-2xl">
            <span className="text-[11px] uppercase tracking-[0.22em] text-white/80">
              The Vitality Journal
            </span>
            <h2 className="font-serif-display text-5xl sm:text-6xl tracking-tight text-white mt-3 leading-[0.95]">
              Protocols, not spam.
            </h2>
            <p className="mt-5 text-white/85 leading-relaxed max-w-lg">
              Join the list for evidence-based supplement guides, restocks and
              subscriber-only launches. Unsubscribe anytime.
            </p>

            {done ? (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                data-testid="newsletter-success"
                className="mt-10 inline-flex items-center gap-3 rounded-full bg-white text-[#1a1f1b] px-7 py-4"
              >
                <Check size={18} className="text-[#e85d04]" />
                You're on the list. Welcome to the ritual.
              </motion.div>
            ) : (
              <form onSubmit={submit} data-testid="newsletter-form" className="mt-10 flex flex-col sm:flex-row gap-4 max-w-lg">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@email.com"
                  data-testid="newsletter-input"
                  className="flex-1 bg-transparent border-b border-white/40 text-white placeholder-white/60 py-4 text-lg focus:outline-none focus:border-white transition-colors duration-300"
                />
                <button
                  type="submit"
                  disabled={loading}
                  data-testid="newsletter-submit"
                  className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#1d231e] text-white px-8 py-4 text-sm hover:bg-[#0d100d] transition-colors duration-300 disabled:opacity-60"
                >
                  {loading ? "Joining…" : "Join the list"}
                  <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1" />
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
